module.exports = __webpack_public_path__ + "static/img/casino-banner-02.c2e20da.png";